// extracted by mini-css-extract-plugin
var _1 = "AdminSecurityView-module__formFields--dcfMv";
var _2 = "AdminSecurityView-module__formFooter--l0083";
export { _1 as "formFields", _2 as "formFooter" }
